import React, { useEffect, useRef, useMemo } from 'react';
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartXAxis,
  ChartXAxisItem,
  ChartYAxis,
  ChartYAxisItem,
  ChartLegend,
  ChartYAxisCrosshair,
  ChartYAxisCrosshairTooltip,
  ChartLegendItem,
  ChartTooltip
} from "@progress/kendo-react-charts";
import { useState } from 'react';

export const Overlapchart = ({ data }) => {
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    setFormattedData(data?.map((item) => ({
      x: item.AssetName1,
      y: item.AssetName2,
      value: item.ReportValue,
      positionCount: item.PositionCount,
      TopPositionItem:item.TopPositionItem
    })) || []);
  }, [data])
  const xCategories = [...new Set(data.map((item) => item.AssetName1))];
  const yCategories = [...new Set(data.map((item) => item.AssetName2))];

  const labelContent = (props) => {
    const value = Math.round(props.dataItem.value);
    if(value===100)
    return '';
    else
    return value.toString();
  };
  const topTipContent = ({point}) => {
    return <>{`${point.dataItem.y} Top Positions : ${point.dataItem.TopPositionItem}`}
    <br/>
    {`Number of Common  Position:${point.dataItem.positionCount}`}
    </>;
  };
  const getMapColor = (props) => {
    if (props.dataItem.value > 99.49)
      return '#FFFFFF';
    else if (props.dataItem.value < 20 && props.dataItem.value >= 0)
      return '#E4EBF1';
    else if (props.dataItem.value < 40 && props.dataItem.value >= 20)
      return '#C8D8E4';
    else if (props.dataItem.value < 60 && props.dataItem.value >= 40)
      return '#ADC4D6';
    else if (props.dataItem.value < 80 && props.dataItem.value >= 60)
      return '#91B1C9';
    else if (props.dataItem.value < 100 && props.dataItem.value >= 80)
      return '#7996ab';
  }
  const chartStyle = {
    minWidth: '600px', // Set a minimum width for the chart container
};
  if (formattedData.length > 0)
    return (<div className='mt-3' >
      {
        <>
        <p className='fw-semibold p-0 mb-1'>
          Overlap Analysis
        </p>
        <div className="detail row w-100 m-0 p-3">
          <div className="col-md-8" style={chartStyle}>
            <Chart >
            <ChartTooltip render={topTipContent} />
              <ChartLegend position="top" orientation="vertical" visible={true}>
                <ChartLegendItem
                  markers={{
                    margin: 8,
                    type: "circle",
                  }}
                  labels={{
                    margin: 8,
                  }}
                />
              </ChartLegend>
              <ChartSeries>
                <ChartSeriesItem
                  type="heatmap"
                  xField="x"
                  yField="y"
                  field="value"
                  data={formattedData}
                  labels={{ visible: true, content: labelContent }}
                  markers={{
                    type: "roundedRect",
                    border: {
                      width: 1,
                      color: "#91B1C9",
                    },
                  }}
                  tooltip={{
                    visible: true,
                  }}
                  color={getMapColor}
                />
              </ChartSeries>
              <ChartXAxis >
                <ChartXAxisItem categories={xCategories} labels={{ visible:true ,rotation: 0, 
                content: (e) => {
                    const label = e.value;
                    const maxLength = 5;
                    const truncatedLabel = label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
                    return  truncatedLabel
                },
                //format: "{0}"
               // visual: renderXAxisLabel
                }} 
                
                >
                 <ChartYAxisCrosshair width={0} color="blue">
            <ChartYAxisCrosshairTooltip position="bottom" />
            
          </ChartYAxisCrosshair>
          </ChartXAxisItem>  </ChartXAxis>
            </Chart>
          </div>
          <div className="col-md-2">
          {<LegendComponent colorCode={[
              { colorCode: '#7996ab', value: 80 ,to:100},
              { colorCode: '#91B1C9', value: 60 ,to:80},
              { colorCode: '#ADC4D6', value: 40 ,to:60},
              { colorCode: '#C8D8E4', value: 20 ,to:40},
              { colorCode: '#E4EBF1', value: 0 ,to:20},
            ]} />}
          </div>
        </div>
        </>
      }
    </div>
    );
  else <>

  </>
}

const LegendComponent = ({ colorCode }) => {
  return <div className='d-flex flex-column h-100 w-50 '>
    {colorCode.map((item, index) => {
      return <>
        <div style={{ backgroundColor: item.colorCode }} className='flex-grow-1 d-flex w-50 position-relative'>
          {item.to===100 && <span className='m-auto position-absolute' style={{top:'0%',left:'120%'}}>{item.to}</span>}
          <span className='m-auto position-absolute' style={{top:'90%',left:'120%'}}>{item.value}</span>
        </div>
      </>
    })}
  </div>
}
